import './footer.css';
import { Link } from 'react-router-dom';
import footerLogo from '../../Data/Assets/images/IYNS_new_logo.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faInstagram,
  faFacebookF,
  faXTwitter,
  faLinkedinIn,
  faYoutube,
} from '@fortawesome/free-brands-svg-icons';

function Footer() {
  return (
    <div className="container" id="footer">
      <div id="footer-items">
        <div id="footer-col">
          <div className="col" id="footer-logo-col">
            <img src={footerLogo} alt="footer-logo" id="footer-logo"></img>
            <div id="page-title">
              IYNS Research
              <br />
              Foundation
            </div>
          </div>
        </div>
        <div id="footer-menu">
          <Link id="footer-menu-item" to="/membership-form">
            Join Us
          </Link>
          <Link id="footer-menu-item" to="/about">
            About Us
          </Link>
          <Link id="footer-menu-item">Newsletter</Link>
          <Link id="footer-menu-item">Events</Link>
          <Link id="footer-menu-item" to="/contact">
            Contact
          </Link>
        </div>
        <div className="col" id="stay-in-touch-col">
          <p>Stay In Touch</p>
        </div>
        <div id="icons-col">
          <div className="footer-icon">
            <a href="https://www.instagram.com/iyns.in/" target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon icon={faInstagram} />
            </a>
          </div>
          <div className="footer-icon">
            <a href="https://www.facebook.com/YouthIYNS" target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon icon={faFacebookF} />
            </a>
          </div>
          <div className="footer-icon">
            <a href="https://x.com/YouthIyns" target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon icon={faXTwitter} />
            </a>
          </div>
          <div className="footer-icon">
            <a
              href="https://www.linkedin.com/company/indian-youth-nuclear-society-iyns/posts/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faLinkedinIn} />
            </a>
          </div>
          <div className="footer-icon">
            <a
              href="https://www.youtube.com/@IndianYouthNuclearSocietyIYNS"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faYoutube} />
            </a>
          </div>
        </div>
      </div>
      <div className="col" id="line">
        <hr></hr>
      </div>
      <div className="col">
        <p>@ 2025 Copyright IYNS Research Foundation</p>
      </div>
    </div>
  );
}

export default Footer;
